import {
  CheckoutPaymentDetails,
  CheckoutRequest,
  CheckoutResponse,
} from '@checkout/util-models';
import {
  CustomerDetails,
  CustomerMarketingPreferenceDetails,
  DocumentSendMethod,
} from '@domgen/dgx-fe-common';
import { createAction, props } from '@ngrx/store';

export const init = createAction('[Checkout] Init');

export const upsertCustomerDetails = createAction(
  '[Checkout] Upsert Customer Details',
  props<{ customerDetails: CustomerDetails }>()
);

export const upsertCustomerMarketingPreferenceDetails = createAction(
  '[Checkout] Upsert Customer Marketing Preference Details',
  props<{ marketingPreferences: CustomerMarketingPreferenceDetails }>()
);

export const updateDocumentSendMethod = createAction(
  '[Checkout] Update Document Send Method',
  props<{ documentSendMethod: DocumentSendMethod }>()
);

export const checkoutRequest = createAction(
  '[Checkout] Checkout: Request',
  props<{ paymentDetails: CheckoutPaymentDetails }>()
);

export const checkout = createAction(
  '[Checkout] Checkout',
  props<{ checkoutRequests: CheckoutRequest[] }>()
);

export const checkoutSuccess = createAction(
  '[Checkout] Checkout: Success',
  props<{ checkoutResponse: CheckoutResponse }>()
);

export const checkoutFailure = createAction(
  '[Checkout] Checkout: Failure',
  props<{ error: Error }>()
);

export const removeCompletedItems = createAction(
  '[Checkout] Remove Completed Items'
);

export const resetMarketingPreferences = createAction(
  '[Checkout] Reset Marketing Preferences'
);

export const trackCheckoutUnica = createAction(
  '[Checkout] Track Checkout Unica'
);
